module.exports = __webpack_public_path__ + "static/media/login-img.a6b07130.jpg";